import Layout from "../include/layout";
import { Button, Form, Modal } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import $ from "jquery";
import dayjs from 'dayjs'
import { Link, useNavigate } from "react-router-dom";
import { myroutes } from "../../routes/webroute";
import Swal from "sweetalert2";
import { checkAuthenticate } from "../app/providers/authSlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import 'datatables.net-bs5'
import UsersService from "./UsersService";
import EditButton from "../../components/editButtonComponent";
import Filarial from "../include/filarial";


export default function UserIndex() {
    const activeLink = "UTILISATEURS "

    const token = useSelector(state => state.auth.token)
    const [nom, setNom] = useState('')
    const [prenoms, setPrenoms] = useState('')
    const [username, setUsername] = useState('')
    const [telephone, setTelephone] = useState('')
    const [email, setEmail] = useState('')
    const [roles, setRoles] = useState([]); //Liste des roles disponible
    const [selectedRoles, setSelectedRoles] = useState([]);
    const [statutId, setStatutId] = useState('')

    const [editElementId, setEditElementID] = useState('')

    const [users, setUsers] = useState([])
    const navigate = useNavigate()
    //check if user is authenticated
    const dispatch = useDispatch();
    const isAuthenticated = useSelector(state => state.auth.isAuthenticate)

    //Afficher le modal de détail user
    const [isShow, invokeModal] = React.useState(false)
    const initModal = async (modalId) => {
        //console.log(modalId)

        //Recupérer l'id pour l'utiliser dans le bouton Modifier qui est sur le modal
        setEditElementID(modalId)
        await UsersService.show(modalId, token).then((response) => {
            //console.log(response)
            const data = response.data.data
            setNom(data.nom)
            setPrenoms(data.prenoms)
            setUsername(data.username)
            setEmail(data.email)
            setTelephone(data.telephone)
            setStatutId(data.is_active) //get statutId

        }).catch(error => {
            Swal.fire({
                icon: "error",
                text: error.message
            })
            //setValidationError(error.message)
        });

        //Recuperer la liste des roles de l'utilisateur
        await UsersService.getRoleUser(modalId, token).then((response) => {
            //Recupérer les roles avec leurs libelle sous forme de tableau
            const rolesUsers = response.data.data.map(item => item.role)
            //console.log(rolesUsers)

            //Mapper les données pour le select
            setSelectedRoles(rolesUsers.map((options) => ({
                value: options.id,
                label: options.libelleRole,
            })))

        }).catch(error => {
            Swal.fire({
                icon: "error",
                text: error.message
            })
        });

        return invokeModal(!false)
    }

    //get liste statuts
    const fetchUsers = async () => {
        await UsersService.index(token).then((res) => {
            //console.log(res.data.data)
            setUsers(res.data.data.users)
        }).catch(error => {
            console.log(error)
        })

        //initialize datatable
        $(document).ready(function () {
            $('.data-table').DataTable();
        });
    }

    //redirection sur la page edit sans afficher les id dans l'url
    const goToEdit = (param) => {
        navigate(myroutes.users_edit, { state: { id: param } })
    }

    //suppression d'un élément
    const onDelete = (param) => {
        //confirm action
        Swal.fire({
            icon: "warning",
            text: "Voulez-vous confirmer cette action ?",
            showCancelButton: true,
            cancelButtonText: "Non",
            confirmButtonText: "Oui",
            confirmButtonColor: "red"
        }).then(result => {
            if (result.isConfirmed) {
                UsersService.delete(param, token).then((response) => {
                    //console.log(response.data)
                    if (response.data.status !== 200) {
                        Swal.fire({
                            icon: "error",
                            text: response.data.message
                        })
                    } else {
                        Swal.fire({
                            icon: "success",
                            text: response.data.message
                        })
                        fetchUsers()
                    }
                }).catch(e => {
                    Swal.fire({
                        icon: "error",
                        text: e.message
                    })
                    console.log(e)
                })
            }
        })
    }

    //Rendre actif ou inactif un user
    const updateStatut = async (id, statut, table) => {
        Swal.fire({
            icon: "error",
            text: "EndPoint non disponible"
        })
        //let form = {id, statut, table}
        /*await StatutsService.changeStatut(id, statut, table, token).then(response => {
            if (response.data.status !== 200) {
                Swal.fire({
                    icon: "error",
                    text: response.data.message
                })
            } else {
                Swal.fire({
                    icon: "success",
                    text: response.data.message
                })
                fetchUsers()
            }
        }).catch(error => {
            console.log(error)
        })*/
    }

    useEffect(() => {
        fetchUsers();
        // Vérifier si l'utilisateur est connecté lors du chargement de l'application
        dispatch(checkAuthenticate());
        if (!isAuthenticated) {
            //console.log(isAuthenticated)
            //Redirection sur le dashboard
            navigate(myroutes.login)
        }
    }, [dispatch])


    return (
        <Layout>
            <div className="container-xxl flex-grow-1 container-p-y">
            <Filarial activeLink={activeLink} />


                {/* Responsive Datatable */}
                <div className="card shadow-lg mt-3 mb-3">
                    <h5 className="card-header">Liste des utilisateurs <Link className="btn btn-primary btn-sm"
                        to={myroutes.users_create} title="Ajouter">
                        <FontAwesomeIcon icon="fa-solid fa-circle-plus" /></Link></h5>
                    <div className="card-datatable table-responsive px-4 pb-3">
                        <table className="dt-responsive table border-top data-table table-hover ">
                            <thead className="bg-primary">
                                <tr style={{ color: "white" }}>
                                    <th className="cell text-white">N°</th>
                                    <th className="cell text-white">Nom et pénoms </th>
                                    <th className="cell text-white">Email</th>
                                    <th className="cell text-white">Username</th>
                                    <th className="cell text-white">Rôles</th>
                                    <th className="cell text-white">Statuts</th>
                                    <th className="cell text-white">Date modification</th>
                                    <th className="cell text-white">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {users.length > 0 && users.map((item, index) => (
                                    <tr key={index}>
                                        <td className="cell">{index + 1}</td>
                                        <td className="cell">{item.nom + " " + item.prenoms} </td>
                                        <td className="cell">{item.email} </td>
                                        <td className="cell">{item.username}</td>
                                        <td className="cell">{Object.values(item.roles).map((option) => option.libelleRole + ' ')}
                                            {/*item.roles.map(options => (
                                            options.libelleRole + ' '
                                        ))*/}</td>
                                        <td className="cell">
                                            <span className={item.is_active ? 'badge rounded-pill bg-success' : 'badge rounded-pill bg-danger'}>{item.is_active ? "ACTIF" : "INACTIF"}</span>
                                        </td>
                                        <td className="cell">
                                            <span>{dayjs(item.updatedAt).format("DD/MM/YYYY H:m:s")}</span>
                                        </td>
                                        <td className="cell">
                                            <div className="d-flex">
                                                <Button className={item.is_active === true ? "btn btn-sm btn-success bg-success" : "btn btn-sm btn-dark bg-dark"} onClick={() => updateStatut(item.id, item.is_active === true ? "desactivation" : "activation", "users")} title="Changer le statut">
                                                    <i className={item.get_statut === true ? "fas fa-eye" : "fas fa-eye-slash"}></i></Button>&nbsp;&nbsp;
                                                <EditButton action={() => goToEdit(item.id)}></EditButton>&nbsp;&nbsp;
                                                <Button className="btn btn-sm bg-primary" variant="secondary" onClick={() => initModal(item.id)} title="Détails">
                                                    <i className="fas fa-list"></i></Button>
                                                &nbsp;&nbsp;
                                                <Button className="btn btn-sm" variant="danger" onClick={() => onDelete(item.id)} title="Supprimer">
                                                    <i className="fas fa-trash"></i></Button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
                {/*/ Responsive Datatable */}

                <>
                    <Modal show={isShow}>
                        <Modal.Header closeButton onClick={() => invokeModal(false)}>
                            <Modal.Title>Détails utilisateur</Modal.Title>
                            <hr className="mr-0" />
                        </Modal.Header>
                        <Modal.Body>
                            <div className="row">
                                <div className="col-md-6 mb-3">
                                    <Form.Label className="form-label" htmlFor="bs-validation-nom">Nom <i className="text-danger">*</i></Form.Label>
                                    <Form.Control className="form-control" id="bs-validation-nom" type="text" value={nom} readOnly disabled
                                        placeholder="" required={true} maxLength={100} minLength={3} />
                                </div>

                                <div className="col-md-6 mb-3">
                                    <Form.Label className="form-label" htmlFor="bs-validation-prenoms">Prénoms <i className="text-danger">*</i></Form.Label>
                                    <Form.Control className="form-control" id="bs-validation-prenoms" type="text" value={prenoms}
                                        placeholder="" readOnly disabled />
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-6 mb-3">
                                    <Form.Label className="form-label" htmlFor="bs-validation-telephone">Téléphone <i className="text-danger">*</i></Form.Label>
                                    <Form.Control className="form-control" id="bs-validation-telephone" type="number" value={telephone}
                                        placeholder="" readOnly disabled />
                                </div>

                                <div className="col-md-6 mb-3">
                                    <Form.Label className="form-label" htmlFor="bs-validation-email">Email <i className="text-danger">*</i></Form.Label>
                                    <Form.Control className="form-control" id="bs-validation-email" type="email" value={email}
                                        placeholder="" readOnly disabled />
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-6 mb-3">
                                    <Form.Label className="form-label" htmlFor="bs-validation-roles_options">Rôles <i className="text-danger">*</i></Form.Label>
                                    <hr className="m-0" />
                                    {selectedRoles.length > 0 && selectedRoles.map(item => (                                        
                                        <div className="form-check form-check-inline" key={item.value}>
                                            <input className="form-check-input" type="checkbox" id="inlineCheckbox2" readOnly disabled checked />
                                            <label className="form-check-label" htmlFor="inlineCheckbox2">{item.label}</label>
                                        </div>
                                    ))}
                                </div>

                                <div className="col-md-6 mb-3">
                                    <Form.Label className="form-label" htmlFor="bs-validation-username">Username <i className="text-danger">*</i></Form.Label>
                                    <Form.Control className="form-control" id="bs-validation-username" type="text" value={username}
                                        readOnly disabled  />
                                </div>

                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="danger" onClick={() => invokeModal(false)}>
                                Fermer
                            </Button>
                            <Button variant="dark" onClick={() => goToEdit(editElementId)}>
                                Modifier
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </>
            </div>

        </Layout>
    )
}